/* eslint-disable @typescript-eslint/no-floating-promises */

import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Languages } from 'lucide-react'
// import { useNavigate } from 'react-router-dom'

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '@/components/ui/select'
import { cn } from '@/lib/utils'

interface LanguageSelectorProps {
  className?: string
  basic?: boolean
}

export const LanguageSelector: React.FC<LanguageSelectorProps> = ({ className, basic }) => {
  const { i18n } = useTranslation()
  const [language, setLanguage] = useState('en') // Default to English
  // const navigate = useNavigate()

  const normalizeLanguage = (lng: string): string => {
    if (lng.startsWith('es')) {
      return 'es' // Normalize any Spanish variant to 'es'
    }
    return 'en' // Default to English for any other case
  }

  useEffect(() => {
    const storedLanguage = localStorage.getItem('language') ?? 'en'
    const currentLanguage = normalizeLanguage(storedLanguage)
    setLanguage(currentLanguage)
  }, [i18n.language])

  const changeLanguage = (value: string): void => {
    // console.log({ value })
    const newLanguage = value === 'en' ? 'en' : 'es'
    i18n.changeLanguage(newLanguage)
    setLanguage(newLanguage)
    localStorage.setItem('language', newLanguage)
    // navigate(`/${newLanguage}`)
  }

  return (
    <>
      {
        basic === true
          ?
            <Select onValueChange={changeLanguage} value={language}>
              <SelectTrigger className={cn('w-auto text-primary', className, 'border-none', 'basic-select')}>
                <Languages className='mr-2' size={20} /> <span>{language.toUpperCase()}</span>
              </SelectTrigger>
              <SelectContent className='border-none'>
                <SelectItem value='en'>EN</SelectItem>
                <SelectItem value='es'>ES</SelectItem>
              </SelectContent>
            </Select>
          : (
            <Select onValueChange={changeLanguage} value={language}>
              <SelectTrigger className={cn('w-[100px] text-primary', className)}>
                <Languages className='mr-2' size={20} />
                <SelectValue placeholder={language.toUpperCase()} />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value='en'>EN</SelectItem>
                <SelectItem value='es'>ES</SelectItem>
              </SelectContent>
            </Select>
            )
      }
    </>
  )
}
